import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HTML_LANG, localeFromPath } from "@/lib/locale";

/**
 * Keeps three things in lockstep:
 *   URL locale prefix  ↔  i18next active language  ↔  <html lang="…">
 *
 * The URL is the source of truth. When it changes (regardless of whether the
 * user typed it, clicked the toggle, or hit back/forward), we drive i18next
 * and the document element to match.
 */
export function LocaleProvider({ children }) {
  const { pathname } = useLocation();
  const locale = localeFromPath(pathname);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
    document.documentElement.setAttribute("lang", HTML_LANG[locale] || "en");
  }, [locale, i18n]);

  return children;
}

export default LocaleProvider;
